export interface BinaryOption {
  label: string;
  value: string;
}

export const binaryOptions: BinaryOption[] = [
  {
    label: 'Sí',
    value: 'Sí',
  },
  {
    label: 'No',
    value: 'No',
  },
];
